export default __webpack_public_path__ + "static/media/image_17.865a27fe.jpg";